module.exports = __webpack_public_path__ + "media/src/application/media/svg/icon-30-e07bc06f259f4612488c06a710ed7a55.svg";